import { Link, Outlet, useParams } from "@tanstack/react-router";
import { CircleDashed } from "lucide-react";
import { INSIGHT_TABS } from "../../nav";
import { SubNav } from "../../components/sub-nav";
import { useWorkspace } from "../../lib/workspace";

export function InsightsLayout() {
  const { project } = useWorkspace();
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h1 className="font-display text-xl font-semibold tracking-tight">Insights</h1>
        <p className="mt-1 text-sm text-fg-muted">Ask a question of your events and see the answer as a chart and a table.</p>
      </div>
      <SubNav
        label="Insight types"
        projectId={project.id}
        items={INSIGHT_TABS.map((t) => ({ to: `/p/$projectId/insights/${t.key}`, label: t.label, soon: !t.live }))}
      />
      <Outlet />
    </div>
  );
}

const SOON_COPY: Record<string, { title: string; body: string }> = {
  stickiness: {
    title: "Stickiness",
    body: "How many days a week (or month) people come back to do something — the shape of habit, not just totals.",
  },
  lifecycle: {
    title: "Lifecycle",
    body: "New, returning, resurrecting and dormant users per period, so you can see whether growth is real.",
  },
  sql: {
    title: "SQL",
    body: "Query your events directly with safe, tenant-isolated SQL — the same engine the AI analyst uses.",
  },
};

export function InsightSoon() {
  const { kind } = useParams({ from: "/p/$projectId/insights/$kind" });
  const { project } = useWorkspace();
  const copy = SOON_COPY[kind];
  return (
    <div className="flex max-w-xl flex-col gap-3 rounded-lg border border-dashed border-border-strong p-6">
      <p className="flex items-center gap-1.5 text-xs font-medium text-fg-muted">
        <CircleDashed aria-hidden className="size-3.5" /> Coming in a later release
      </p>
      <h2 className="font-display text-lg font-semibold">{copy?.title ?? "Not available"}</h2>
      <p className="text-sm text-fg-muted">{copy?.body ?? "This insight type doesn't exist."}</p>
      <Link
        to="/p/$projectId/insights/trends"
        params={{ projectId: project.id }}
        className="text-sm font-medium text-accent underline-offset-4 hover:underline"
      >
        Go to Trends
      </Link>
    </div>
  );
}
